import React from "react";
import { Rounded } from "../../assets/images";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";

type UserPostImageUploadProps = {
  imageUpload: string[];
  totalImages: number;
  handleClick: (index: number) => void;
  setShowAllImages: React.Dispatch<React.SetStateAction<number | null>>;
  imageLoading?: boolean;
};
const UserPostImageUpload: React.FC<UserPostImageUploadProps> = ({
  imageUpload,
  totalImages,
  handleClick,
  setShowAllImages,
  imageLoading,
}) => {
  const isBlobUrl = (url: string | undefined) => {
    if (!url) return false;
    return url.startsWith("blob:") || url.startsWith("data:image/jpeg;");
  };
  if (imageLoading) {
    return (
      <div className="flex items-center w-full h-full bg-[#ECE6E6] justify-center">
        <img src={Rounded} alt="" className="h-10 w-10 animate-spin" />
      </div>
    );
  }
  return (
    <div className="flex border w-full relative">
      {imageUpload && imageUpload.length > 4 ? (
        <div className="grid grid-rows-3 grid-flow-col grid-cols-3 w-full">
          {imageUpload.map(
            (image, i) =>
              i === 0 && (
                <div
                  className={`row-span-full col-span-2 border relative overflow-hidden cursor-pointer ${
                    totalImages === i ? "selected" : ""
                  }`}
                  onClick={() => handleClick(i)}
                  key={i}
                >
                  <img
                    src={isBlobUrl(image) ? image : ipfsGatewayImage(image)}
                    alt=""
                    loading="lazy"
                    className="w-full object-cover h-full object-center"
                  />
                </div>
              )
          )}
          {imageUpload &&
            imageUpload.slice(1, 4).map((image, i) => (
              <div
                className="relative overflow-hidden"
                key={i}
                onClick={() => handleClick(i + 1)}
              >
                <div className="border w-full h-full relative cursor-pointer">
                  <img
                    src={isBlobUrl(image) ? image : ipfsGatewayImage(image)}
                    alt=""
                    loading="lazy"
                    className="w-full object-cover h-full object-center"
                  />
                </div>
                {i === imageUpload.slice(1, 4).length - 1 && (
                  <div
                    className="w-full h-full text-white text-center bg-[rgba(0,0,0,0.7)] top-0 right-0 absolute font-Poppins text-2xl items-center flex justify-center cursor-pointer"
                    key={i}
                    onClick={() => setShowAllImages(4)}
                  >
                    <p>+ {imageUpload.length - 4}</p>
                  </div>
                )}
              </div>
            ))}
        </div>
      ) : imageUpload && imageUpload.length > 3 ? (
        <div className="grid grid-cols-2 w-full">
          {imageUpload.map((image, index) => (
            <div
              className={`flex w-full border border-solid relative overflow-hidden cursor-pointer ${
                totalImages === index ? "selected" : ""
              }`}
              onClick={() => handleClick(index)}
              key={index}
            >
              <img
                src={isBlobUrl(image) ? image : ipfsGatewayImage(image)}
                alt=""
                loading="lazy"
                className="w-full object-cover object-center"
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="flex w-full">
          {imageUpload?.length === 1
            ? imageUpload.map((image, index) => (
                <div className="flex w-full">
                  <div
                    className="w-full relative cursor-pointer h-auto overflow-hidden"
                    onClick={() => handleClick(index)}
                  >
                    <img
                      key={index}
                      src={isBlobUrl(image) ? image : ipfsGatewayImage(image)}
                      alt=""
                      loading="lazy"
                      className="w-full object-cover object-center"
                    />
                  </div>
                </div>
              ))
            : imageUpload?.length === 2
            ? imageUpload.map((image, i) => (
                <div className="flex w-full flex-wrap h-auto">
                  <div
                    className="cursor-pointer flex border-2 h-auto relative"
                    onClick={() => handleClick(i)}
                    key={i}
                  >
                    <img
                      src={isBlobUrl(image) ? image : ipfsGatewayImage(image)}
                      alt=""
                      loading="lazy"
                      className="w-full object-cover h-auto object-center"
                    />
                  </div>
                </div>
              ))
            : imageUpload.length === 3 && (
                <div className="flex w-full">
                  <div className="flex w-full border h-auto relative cursor-pointer">
                    {imageUpload.map(
                      (image, i) =>
                        i === 0 && (
                          <div
                            className="flex w-full"
                            onClick={() => handleClick(i)}
                          >
                            <img
                              src={
                                isBlobUrl(image)
                                  ? image
                                  : ipfsGatewayImage(image)
                              }
                              loading="lazy"
                              alt=""
                              key={i}
                            />
                          </div>
                        )
                    )}
                  </div>
                  <div className="grid grid-rows-2 h-auto w-full">
                    {imageUpload.map(
                      (image, i) =>
                        i !== 0 && (
                          <div className="h-[200px] flex w-full" key={i}>
                            <div
                              className="w-full flex-1 border h-full relative overflow-hidden "
                              onClick={() => handleClick(i)}
                            >
                              <img
                                src={
                                  isBlobUrl(image)
                                    ? image
                                    : ipfsGatewayImage(image)
                                }
                                loading="lazy"
                                alt=""
                                className=" object-cover h-full object-center w-full"
                              />
                            </div>
                          </div>
                        )
                    )}
                  </div>
                </div>
              )}
        </div>
      )}
    </div>
  );
};

export default UserPostImageUpload;
